import { BlobProvider } from "@react-pdf/renderer";
import PdfDocument from "../PdfDocument";

const DocumentPreview = () => (
    <BlobProvider document={<PdfDocument />}>
      {({ blob, url, loading }) =>
        loading ? (
          'Loading document...'
        ) : (
          <iframe src={url} style={{ width: '100%', height: '90vh' }} title="PDF Preview" />
        )
      }
    </BlobProvider>
);

export default DocumentPreview;